import { createContext } from 'react'

import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

import type { ListViewSurface } from '../../helpers/listViewSurface'
import type { ActionPanelVariant, PanelAction } from '../types'

export type ActionPanelContextValue = {
  /** What to render. Derived, never stored — see {@link ActionPanelVariant}. */
  variant: ActionPanelVariant
  /**
   * The buyer's stored preference, for the header toggle to flip. Not for
   * deciding what to render — that is `variant`, which is not the same thing on
   * mobile.
   */
  isExpanded: boolean
  /**
   * Sets and persists `isExpanded`.
   * Set on user action. Not set on resize, which just affects `variant`.
   */
  setIsExpanded: (isExpanded: boolean) => void
  /**
   * How many actions are registered. Drives the panel's width, so it comes from
   * the registry's length rather than a maintained constant.
   */
  actionCount: number
  /**
   * Resolves the registry for one row. Called once per row during render — not
   * a hook, and not one component per action per row, so adding an action costs
   * nothing in subscriptions.
   */
  getActions: (listing: CombinedListingSearchResult) => PanelAction[]
  /**
   * Which List View this is, per analytics spec.
   */
  surface?: ListViewSurface
}

export const ActionPanelContext = createContext<ActionPanelContextValue | null>(
  null
)
